import { nextFrame } from "@escapio/shared/event/next-frame";
import { hasTracking } from "@escapio/shared/state/client-settings";

window._paq = window._paq || [];

export async function track(category, action, label, value) {
	await nextFrame();
	console.info("Track:", {
		category,
		action,
		label,
		value,
	});

	if (!hasTracking) return;

	window._paq.push(["trackEvent", category, action, label, value]);
}

export function trackImpression(name, piece, target) {
	console.info("Track content impression:", {
		name,
		piece,
		target,
	});

	if (!hasTracking) return;
	window._paq.push(["trackContentImpression", name, piece, target]);
}

export function trackContentInteraction(
	name,
	piece,
	target,
	interactionType = "click",
) {
	console.info("Track content interaction:", {
		interactionType,
		name,
		piece,
		target,
	});

	if (!hasTracking) return;
	window._paq.push([
		"trackContentInteraction",
		interactionType,
		name,
		piece,
		target,
	]);
}

const previousTopics = [];
export function trackPageOnce(eventCategory, action, eventLabel, value) {
	if (!hasTracking) return;
	const topic = `${eventCategory}/${action}/${eventLabel}`;
	if (!previousTopics.includes(topic)) {
		previousTopics.push(topic);
		track(eventCategory, action, eventLabel, value);
	}
}

export function trackEcommerceItemAdded(
	hotelId,
	price,
	quantity = 1,
	categories = [],
) {
	const sku = hotelId;
	const productName = "Escapio Buchung";
	console.info("trackEcommerceItemAdded:", {
		sku,
		productName,
		price,
		categories,
		quantity,
	});

	if (!hasTracking) return;
	window._paq.push([
		"addEcommerceItem",
		sku,
		productName,
		categories,
		price,
		quantity,
	]);
}

export function trackEcommerceOrder(bookingId, price) {
	console.info("trackEcommerceOrder:", {
		bookingId,
		price,
	});

	if (!hasTracking) return;
	window._paq.push(["trackEcommerceOrder", bookingId, price]);
}
